import { useCallback, useState } from 'react';

import { SnackbarEnum } from 'pages/ParentHelper/providers/SnackbarProvider/types';

import type { SnackbarCloseReason } from '@mui/material';
import type { SnackbarType } from 'pages/ParentHelper/providers/SnackbarProvider/types';
import type { SyntheticEvent } from 'react';

export const useSnackbar = () => {
  const [open, setOpen] = useState<SnackbarType | null>(null);

  const onClose = useCallback(
    (_: SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
      if (reason === 'clickaway') {
        return;
      }

      setOpen(null);
    },
    [],
  );

  const onOpen = useCallback((type: SnackbarType | null) => {
    setOpen(type);
  }, []);

  return {
    open,
    onOpen,
    onClose,
    isFeedbackOpened: open === SnackbarEnum.Feedback,
    isDeletingOpened: open === SnackbarEnum.Deleting,
  };
};
